import messages from './ListeStructures.json'
import swal from 'sweetalert2'
export default {
  name: "Structures",

  i18n: messages,

  components: {
    Element,
    swal
  },

  data() {
    return {
      search: '',
      data: {
        structures : [],
        user : null
      },
      control: {
        emptyResult: null,
      }
    }
  },

  mounted() {
    this.updateData();
  },

  methods: {
    updateData() {
      this.$eventHub.$emit(this.$eventHub.LOADING.START);
      this.$axios.get('rest/bd/structure/user/me?users=true').then(
        response => {
          this.updateDataSuccess(response.data)
          this.$eventHub.$emit(this.$eventHub.LOADING.END);
        },
        error => {
          this.updateDataFailed(error.response)
          this.$eventHub.$emit(this.$eventHub.LOADING.END);
        }
      )
    },

    /**
     * Données filtrées après recherche
     */
    filteredList() {
      const data = this.data.structures.filter(structure => {
        return structure.nom.toLowerCase().includes(this.search.toLowerCase())
      })

      data.sort((a, b) => a.path < b.path ? -1 : 1)

      return data
    },

    /**
     * Appel service backend de suppression
     * @param {*} id
     */
    deleteOne(structure) {
      swal({
        title: this.$t('confirmation.suppression.titre'),
        text: this.$t('confirmation.suppression.texte'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonClass: 'btn btn-success btn-fill',
        cancelButtonClass: 'btn btn-danger btn-fill',
        confirmButtonText: this.$t('confirmation.suppression.valider'),
        cancelButtonText: this.$t('confirmation.suppression.annuler'),
        buttonsStyling: false
      }).then( response => {
      this.$eventHub.$emit(this.$eventHub.LOADING.START);
      this.$axios.delete('rest/bd/structure/' + structure).then(
        response => {
          // Mise à jour IHM
          const index = this.data.structures.findIndex(item => item.id === structure)
          this.data.structures.splice(index, 1)
          // Confirm message
          this.$eventHub.$emit(this.$eventHub.LOADING.END);
        })
        .catch( error => {
          const err = error.response.data
          this.$notify.error({
            title: this.$t('notifications.' + err.businessCode + '.title'),
            message: this.$t('notifications.' + err.businessCode + '.message')
          })
          this.$eventHub.$emit(this.$eventHub.LOADING.END);
        })
      })
    },

    /**
     * Application du filtre de recherche
     */
    filteredItems() {
      return this.data.structures.filter(structure => {
        return structure.nom.toLowerCase().indexOf(this.search.toLowerCase()) > -1
      })
    },

    /**
     * On vérifie si TGI n'est pas le parent d'une structure
     */
    isParentTGI(structure) {
      return !(this.$val.isDefined(structure.parent) && structure.parent.id !== 1)
    },

    /**
     * Sauvegarde de la structure sur laquelle l'utilisateur a cliqué avant d'aller sur la route suivante
     * @param {*} structure
     */
    gotoStructure(structure) {
      localStorage.setItem('selectedStructure', JSON.stringify(structure))
      this.$router.push({ path: '/pages/admin/structure/detail/' + structure.id })
    },

        /**
     * Sauvegarde de la structure sur laquelle l'utilisateur a cliqué avant d'aller sur la liste des users
     * @param {*} structure
     */
    goToGestionUtilisateurs(structure) {
      localStorage.setItem('selectedStructure', JSON.stringify(structure))
      this.$router.push({ path: '/pages/admin/user/structure/' + structure.id })
    },

    gotoUserStructure(structure) {
      localStorage.setItem('selectedStructure', JSON.stringify(structure))
      this.$router.push({ path: '/pages/admin/user/structure/' + structure.id })
    },

    /**
     * Appelé lorsque la récupération des données s'est bien passée
     */
    updateDataSuccess(data) {
      if (this.$val.isDefined(data) && data.length > 0) {
        this.data.structures = data
        this.control.emptyResult = false
      } else {
        this.control.emptyResult = true
      }
    },

    /**
     * Appelé lorsque la récupération des données s'est mal passée
     */
    updateDataFailed(error) {
      //on notifie l'erreur a l'utilisateur
      this.$notify.error({
        title: this.$t('notifications.error.title'),
        message: this.$t('notifications.error.message')
      })
    }
  }
}
